import { render, staticRenderFns } from "./FilterTokenPricedMobile.vue?vue&type=template&id=7021700a"
import script from "./FilterTokenPricedMobile.vue?vue&type=script&lang=ts"
export * from "./FilterTokenPricedMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports